var map = {
	"./AnnouncementsWidget.vue": 23246,
	"./ResourcesWidget.vue": 48671,
	"./StatsWidget.vue": 3463,
	"./TemplateSelectWidget.vue": 87227,
	"./TopCampaignsWidget.vue": 50008,
	"./UpsellBox.vue": 96927,
	"./UpsellWidget.vue": 70154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;